import React, { Component } from "react";
import { connect } from "react-redux";

import EventsListComponent from "./EventsListComponent";

import { fetchEvents } from "Thunks";

import { LAYOUT_DISPOSITIONS } from "Config";

export class EventsList extends Component {
  componentDidMount() {
    const { fetchEvents, disposition } = this.props;

    let limit = 0;
    for (const blocType of disposition || []) {
      limit += LAYOUT_DISPOSITIONS.EVENT[blocType];
    }
    fetchEvents({ limit: limit === 0 ? 8 : limit });
  }

  render() {
    return <EventsListComponent {...this.props} />;
  }
}

// Connected Component
const mapStateToProps = state => ({
  events: state.events.items,
  fetching: state.events.fetching,
  fetched: state.events.fetched,
  lng: state.params.lng
});

const mapDispatchToProps = dispatch => ({
  fetchEvents: options => dispatch(fetchEvents(options))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventsList);



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/EventsList/index.js